import React, { Component } from 'react';
import PropTypes from 'prop-types';

import { withRouter } from 'react-router-dom';

import {
  Col, Row,
  Modal, ModalHeader, ModalBody, ModalFooter, Button, Media, Spinner
} from 'reactstrap';

import { connect } from 'react-redux';
import Moment from 'react-moment';

import { Check, X } from 'react-feather';

import ScrollArea from 'react-scrollbar';

import { Table, Column, HeaderCell, Cell, ColumnGroup } from 'rsuite-table';
import 'rsuite-table/dist/css/rsuite-table.css';

import ReactTooltip from 'react-tooltip';

import bell from '../../../../assets/icons/alarm.svg';
import gear from '../../../../assets/icons/cog.svg';
import plus from '../../../../assets/icons/plus.svg';


import { storage } from '../../../../lib/firebase';

import {
  getCompanyChanges,
  cancelUnclaimedOutreachEmails,
} from '../../../../actions/company';

import {
  cancelCampaignRequest,
  getCompanyVouchers,
  sortCompanyOutreachVouchers,
  getCompanyOutreachCampaigns,
} from '../../../../actions/vouchers';


import {
  getOutreachListTooltips,
} from '../../../../actions/contentManagement';

import formattedNumber from '../../../components/FormattedNumber/FormattedNumber';
import CustomSortIcons from '../../../components/CustomSortIcons/CustomSortIcons';

import CampaignDetails from './CampaignDetails';

import line from '../../../../assets/images/line.svg';
import defaultPrimary from '../../../../assets/images/defaultPrimary.png';
import defaultLogo from '../../../../assets/images/defaultLogo.png';

const WITH_COMMISSION_WIDTH = 0.07;
const WITHOUT_COMMISSION_WIDTH = 0.08;

class VouchersList extends Component {
  static propTypes = {
    user: PropTypes.shape(),
    admin: PropTypes.shape(),
    vouchers: PropTypes.shape(),
    cancelRequest: PropTypes.func.isRequired,
    sortVouchers: PropTypes.func.isRequired,
    refresh: PropTypes.func.isRequired,
    cancelUnclaimedEmails: PropTypes.func.isRequired,
    fetchNewOutreachTooltips: PropTypes.func.isRequired,
  };

  static defaultProps = {
    vouchers: {},
    user: {},
    admin: {},
  };

  constructor(props) {
    super(props);
    this.state = {
      error: null,
      loading: false,
      previewModal: false,
      readMore: false,
      sortColumn: 'created_at',
      sortType: 'asc',
      tableHeight: 340,
      width: 1000,
      height: 340,
    };
  }

  componentDidMount() {
    const { user, fetchNewOutreachTooltips } = this.props;

    if (user && Object.keys(user).length > 0) {

      fetchNewOutreachTooltips();

      if (user.company) {
        if (user.role === 'teamOwner') {
          this.setState({ showNoPermission: false });
        } else {
          const { roles } = this.props;

          if (roles && roles[user.role] && roles[user.role].permissions && roles[user.role].permissions.manageVouchers) {
            this.setState({ showNoPermission: false });
          } else {
            this.setState({ showNoPermission: false });
          }
        }
      }
    } else {
    }

    console.log('this.tableWrapper', this.tableWrapper);
    console.log('this.tableWrapper.getBoundingClientRect', this.tableWrapper.getBoundingClientRect());

    const getBoundingClientRect = this.tableWrapper.getBoundingClientRect();

    window.addEventListener('resize', this.handleResize);

    if (getBoundingClientRect && getBoundingClientRect.width) {
      this.setState({ width: getBoundingClientRect.width, height: getBoundingClientRect.height });
    }

    /*
    const resizeObserver = new ResizeObserver((event) => {
      // Depending on the layout, you may need to swap inlineSize with blockSize
      // https://developer.mozilla.org/en-US/docs/Web/API/ResizeObserverEntry/contentBoxSize

      console.log('resizeObserver', event);

      this.setState({ width: event[0].contentBoxSize[0].inlineSize, height: event[0].contentBoxSize[0].blockSize });
    });

    if (this.tableWrapper) {
      this.modalScrollbar.scrollTop();
    }

    resizeObserver.observe(this.tableWrapper); */
  }

  handleResize = () => {
    console.log('this.tableWrapper handleResize', this.tableWrapper);

    if (this.tableWrapper) {
      const getBoundingClientRect = this.tableWrapper.getBoundingClientRect();

      console.log('this.tableWrapper handleResize 2', getBoundingClientRect);

      if (getBoundingClientRect && getBoundingClientRect.width) {
        this.setState({ width: getBoundingClientRect.width, height: getBoundingClientRect.height });
      }
    }
  };


  openPreview = async (e, campaignData) => {
    const { company } = this.props;
    const { availableVouchers, discount } = campaignData;

    if (company) {
      let companyPrimaryVoucherImage;
      let logoImage;

      if (company.primaryVoucherImage && company.logo) {
        const primaryVoucherImageReference = storage.ref(company.primaryVoucherImage);
        const logoReference = storage.ref(company.logo);

        await primaryVoucherImageReference.getDownloadURL().then((url) => {
          companyPrimaryVoucherImage = url;
        }).catch((err) => {
          console.log(err);
        });

        await logoReference.getDownloadURL().then((url) => {
          logoImage = url;
        }).catch((err) => {
          console.log(err);
        });
      }

      this.setState({ availableVouchers, discount, previewModal: true, primaryVoucherImage: companyPrimaryVoucherImage || null, logo: logoImage || null });
    }
  }

  closePreview = () => {
    this.setState({ previewModal: false, primaryVoucherImage: null, logo: null });
  }

  openCampaignDetails = async (e, campaignData) => {
    const { user, company, fetchCompanyChanges } = this.props;
    const { id } = campaignData;

    if (company) {
      let companyPrimaryVoucherImage;
      let logoImage;
      let voucherImages = [];

      if (user.company) {
        await fetchCompanyChanges(user.company, id);
      }

      if (company.logo) {
        const logoReference = storage.ref(company.logo);

        await logoReference.getDownloadURL().then((url) => {
          logoImage = url;
        }).catch((err) => {
          console.log(err);
        });
      }

      if (company.primaryVoucherImage) {
        const primaryVoucherImageReference = storage.ref(company.primaryVoucherImage);

        await primaryVoucherImageReference.getDownloadURL().then((url) => {
          companyPrimaryVoucherImage = url;
        }).catch((err) => {
          console.log(err);
        });
      }

      let promises = [];

      if (company.voucherImages && company.voucherImages.length) {
        company.voucherImages.map(async (image) => {
          const imageRef = storage.ref(image);

          promises.push(imageRef.getDownloadURL().then((url) => {
            voucherImages.push(url);
          }).catch((err) => {
            console.log(err);
          }));
        })
      }

      Promise.all(promises).then(() => {
        this.setState({
          campaignDetailsId: id,
          campaignDetails: {
            ...campaignData,
            company,
            voucherImages: voucherImages || [],
            primaryVoucherImage: companyPrimaryVoucherImage || null,
            logo: logoImage || null,
          }
        });
      }).catch(err => {
        console.log(err);
        this.setState({
          campaignDetailsId: id,
          campaignDetails: {
            ...campaignData,
            company,
            voucherImages: voucherImages || [],
            primaryVoucherImage: companyPrimaryVoucherImage || null,
            logo: logoImage || null,
          }
        });
      })
    }
  }

  reloadCampaignDetails = async () => {
    const { user, adminViewAsCompany, company, getVouchers, fetchCompanyChanges } = this.props;
    const { campaignDetailsId } = this.state;

    if (user.company) {
      await fetchCompanyChanges(user.company, campaignDetailsId);
      await getVouchers(user.company);
    } else if (adminViewAsCompany) {
      await fetchCompanyChanges(adminViewAsCompany, campaignDetailsId);
      await getVouchers(adminViewAsCompany);
    }

    const { vouchersArr } = this.props;

    const campaignData = vouchersArr.find(element => element.id === campaignDetailsId);

    if (company) {
      this.setState((prevState) => ({
        campaignDetails: {
          ...prevState.campaignDetails,
          ...campaignData,
        }
      }));
    }
  }

  closeCampaignDetails = () => {
    this.setState({ campaignDetailsId: null, campaignDetails: null });
  }


  toggleReadMore = () => {
    this.setState((prevState) => ({ readMore: !prevState.readMore }))
  }

  togglePreviewStep = (step) => {
    this.setState({ previewStep: step });
  }

  sort = (sortColumn, sortType) => {
    const { sortVouchers } = this.props;

    sortVouchers(sortColumn, sortType);

    this.setState({ sortType, sortColumn });
  }

  cancelCampaignRequest = (campaignId) => {
    this.setState({ buttonPressed: campaignId });

    const { cancelRequest } = this.props;

    cancelRequest(campaignId).then(() => {
      this.setState({ buttonPressed: null });
    }).catch(err => {
      console.log(err);
      this.setState({ buttonPressed: null });
    });
  }

  toggleTableSize = () => {
    const { tableHeight } = this.state;

    console.log('toggleTableSize', tableHeight);

    if (tableHeight === 220) {
      this.setState({ tableHeight: 470 });
    } else {
      this.setState({ tableHeight: 220 });
    }
  }

  copyCampaignLink = async (id) => {
    const { hostname, search, pathname } = window.location;

    let text;

    console.log('copyCampaignLink hostname', hostname);
    if (hostname.includes('app.steppr.com')) {
      text = `https://steppr.com/campaign/${id}`;
    } else {
      text = `https://steppr-client.web.app/campaign/${id}`;
    }
    try {
      await navigator.clipboard.writeText(text);
    } catch (e) {
    }
  }

  openEmailList = (recipients) => {
    const emails = recipients.split(/[\n,]+/);

    this.setState({ emailListOpen: true, emailListRecipients: emails });
  }

  closeEmailList = (recipients) => {
    this.setState({ emailListOpen: false, emailListRecipients: null });
  }

  cancelUnclaimedEmails = (outreachVoucherId) => {
    const { adminViewAsCompany, user, cancelUnclaimedEmails, fetchCompanyOutreachCampaigns } = this.props;

    console.log('cancelUnclaimedEmails', outreachVoucherId);
    this.setState({ cancelSpinner: outreachVoucherId });

    cancelUnclaimedEmails({ outreachVoucherId }).then((res) => {
      setTimeout(() => {
        if (adminViewAsCompany) {
          fetchCompanyOutreachCampaigns(adminViewAsCompany);
        } else {
          fetchCompanyOutreachCampaigns(user.company);
        }

        this.setState({ cancelSpinner: null });
      }, 1050);
    });
  }

  goToCreate = () => {
    const { history } = this.props;
    history.push('/new-outreach');
  }

  render() {
    const { company, outreachVouchers, dashboardTooltips, showNoPermission, branding } = this.props;
    const {
      previewModal,
      readMore,
      sortType,
      sortColumn,
      availableVouchers,
      discount,
      previewStep,
      buttonPressed,
      tableHeight,
      width,
      height,

      emailListOpen,
      emailListRecipients,
      cancelSpinner,
    } = this.state;

    console.log('dashboardTooltips', dashboardTooltips);

    return (
      <div>
        <div>
          <h4 style={{ fontSize: 16, paddingTop: 20, paddingLeft: 22, fontWeight: 600, marginBottom: 0 }}>VouchReach <span> <Media src={plus} style={{ width: 15, heiht: 15, marginTop: -2, cursor: 'pointer' }} onClick={() => this.goToCreate()} /> </span></h4>
        </div>
        <div ref={(el) => { this.tableWrapper = el; }} id="tableWrapper-1" class="table-responsive" style={{ padding: 0, borderRadius: '20px 20px 0 0' }}>
          {dashboardTooltips.name ? (
            <ReactTooltip place="right" className='react-tooltip-custom-class' effect="solid" id='name-tooltip'>
              <span>{dashboardTooltips.name ? dashboardTooltips.name.value : ''}</span>
            </ReactTooltip>
          ) : (null)}

          {dashboardTooltips.claimBy ? (
            <ReactTooltip place="right" className='react-tooltip-custom-class' effect="solid" id='claimBy-tooltip'>
              <span>{dashboardTooltips.claimBy ? dashboardTooltips.claimBy.value : ''}</span>
            </ReactTooltip>
          ) : (null)}

          {dashboardTooltips.claimed ? (
            <ReactTooltip place="right" className='react-tooltip-custom-class' effect="solid" id='claimed-tooltip'>
              <span>{dashboardTooltips.claimed ? dashboardTooltips.claimed.value : ''}</span>
            </ReactTooltip>
          ) : (null)}

          {dashboardTooltips.emailList ? (
            <ReactTooltip place="right" className='react-tooltip-custom-class' effect="solid" id='emailList-tooltip'>
              <span>{dashboardTooltips.emailList ? dashboardTooltips.emailList.value : ''}</span>
            </ReactTooltip>
          ) : (null)}

          {dashboardTooltips.redeemBy ? (
            <ReactTooltip place="right" className='react-tooltip-custom-class' effect="solid" id='redeemBy-tooltip'>
              <span>{dashboardTooltips.redeemBy ? dashboardTooltips.redeemBy.value : ''}</span>
            </ReactTooltip>
          ) : (null)}

          {dashboardTooltips.redeemed ? (
            <ReactTooltip place="right" className='react-tooltip-custom-class' effect="solid" id='redeemed-tooltip'>
              <span>{dashboardTooltips.redeemed ? dashboardTooltips.redeemed.value : ''}</span>
            </ReactTooltip>
          ) : (null)}

          {dashboardTooltips.sends ? (
            <ReactTooltip place="right" className='react-tooltip-custom-class' effect="solid" id='sends-tooltip'>
              <span>{dashboardTooltips.sends ? dashboardTooltips.sends.value : ''}</span>
            </ReactTooltip>
          ) : (null)}

          {dashboardTooltips.sent ? (
            <ReactTooltip place="right" className='react-tooltip-custom-class' effect="solid" id='sent-tooltip'>
              <span>{dashboardTooltips.sent ? dashboardTooltips.sent.value : ''}</span>
            </ReactTooltip>
          ) : (null)}

          {dashboardTooltips.cancelUnclaimed ? (
            <ReactTooltip place="right" className='react-tooltip-custom-class' effect="solid" id='cancelUnclaimed-tooltip'>
              <span>{dashboardTooltips.cancelUnclaimed ? dashboardTooltips.cancelUnclaimed.value : ''}</span>
            </ReactTooltip>
          ) : (null)}
          

          <Button color="primary" className="company-dashboard-campaigns-table-toggle" onClick={this.toggleTableSize} >
            {tableHeight === 340 ? '\u23F7' : '\u23F6'}
          </Button>

          <Table
            style={{ fontSize: 14, paddingLeft: 17, borderLeft: 0, borderRight: 0 }}
            sortType={sortType}
            sortColumn={sortColumn}
            data={outreachVouchers}
            className="company-dashboard-campaigns-table"
            virtualized={true}
            minHeight={tableHeight}
            height={tableHeight}
            onSortColumn={this.sort}
            rowKey='voucherName'
            headerHeight={40}
            rowHeight={50}
          >
            <Column width={width * 0.12} sortable resizable>
              <HeaderCell><div className="display-inline" data-tip data-for='name-tooltip'> Name </div></HeaderCell>
              <Cell dataKey="voucherName">
                {(rowData, rowIndex) => {
                  return (
                    <div>
                      {rowData.voucherName ? (rowData.voucherName) : (null)}
                    </div>
                  )
                }}
              </Cell>
            </Column>


            <Column width={width * 0.11} sortable resizable>
              <HeaderCell><div className="display-inline" data-tip data-for='sent-tooltip'> Sent </div></HeaderCell>
              <Cell dataKey="created_at">
                {(rowData, rowIndex) => {
                  return (
                    <div>
                      {rowData.created_at ? (
                        <Moment format="DD MMM YYYY" locale="=uk">
                          {rowData.created_at.seconds * 1000}
                        </Moment>
                      ) : ('-')}
                    </div>
                  )
                }}
              </Cell>
            </Column>

            <Column width={width * 0.11} sortable resizable>
              <HeaderCell><div className="display-inline" data-tip data-for='sends-tooltip'> Sends </div></HeaderCell>
              <Cell dataKey="emailsCount">
                {(rowData, rowIndex) => {
                  return (
                    <div>
                      {rowData.emailsCount ? (rowData.emailsCount) : ('-')}
                    </div>
                  )
                }}
              </Cell>
            </Column>

            <Column width={width * 0.11} sortable resizable>
              <HeaderCell><div className="display-inline" data-tip data-for='claimed-tooltip'> Claimed </div></HeaderCell>
              <Cell dataKey="claimedCount">
                {(rowData, rowIndex) => {
                  return (
                    <div>
                      {rowData.claimedCount ? (rowData.claimedCount) : ('-')}
                    </div>
                  )
                }}
              </Cell>
            </Column>

            <Column width={width * 0.11} sortable resizable>
              <HeaderCell><div className="display-inline" data-tip data-for='claimBy-tooltip'> Claim By </div></HeaderCell>
              <Cell dataKey="claimBy">
                {(rowData, rowIndex) => {
                  return (
                    <div>
                      {rowData.claimBy ? (
                        <Moment format="DD MMM YYYY" locale="=uk">
                          {rowData.claimBy}
                        </Moment>
                      ) : ('-')}
                    </div>
                  )
                }}
              </Cell>
            </Column>

            <Column width={width * 0.11} sortable resizable>
              <HeaderCell><div className="display-inline" data-tip data-for='redeemed-tooltip'> Redeemed </div></HeaderCell>
              <Cell dataKey="redeemedCount">
                {(rowData, rowIndex) => {
                  return (
                    <div>
                      {rowData.redeemedCount ? (rowData.redeemedCount) : ('-')}
                    </div>
                  )
                }}
              </Cell>
            </Column>

            <Column width={width * 0.11} sortable resizable>
              <HeaderCell><div className="display-inline" data-tip data-for='redeemBy-tooltip'> Redeem By </div></HeaderCell>
              <Cell dataKey="redeemBy">
                {(rowData, rowIndex) => {
                  return (
                    <div>
                      {rowData.redeemBy ? (
                        <Moment format="DD MMM YYYY" locale="=uk">
                          {rowData.redeemBy}
                        </Moment>
                      ) : ('-')}
                    </div>
                  )
                }}
              </Cell>
            </Column>


            <Column width={width * 0.11} resizable>
              <HeaderCell><div data-tip data-for='emailList-tooltip'> Emails List </div></HeaderCell>
              <Cell dataKey="button edit">
                {(rowData, rowIndex) => (
                  <Button color="link" style={{ paddingTop: 0 }} onClick={() => this.openEmailList(rowData.recipients)}>
                    List
                  </Button>
                )}
              </Cell>
            </Column>

            <Column width={width * 0.11} resizable>
              <HeaderCell><div data-tip data-for='cancelUnclaimed-tooltip'> Cancel Unclaimed </div></HeaderCell>
              <Cell dataKey="button edit">
                {(rowData, rowIndex) => (
                  <Button color="link" style={{ paddingTop: 0 }} onClick={() => this.cancelUnclaimedEmails(rowData.id)} disabled={rowData.cancelled}>
                    {rowData.cancelled ? ('Done') : ('Do')}
                    {(cancelSpinner === rowData.id) ? (
                      <Spinner animation="border" variant="primary" style={{ width: '1.3rem', height: '1.3rem' }}> {''} </Spinner>
                    ) : (null)}
                  </Button>
                )}
              </Cell>
            </Column>
          </Table>
        </div>

        <Modal isOpen={emailListOpen} toggle={this.closeEmailList}>
          <ModalBody>
            <Row>
              <Col xs="12">
                Email
              </Col>
              {emailListRecipients ? emailListRecipients.map((email) => (
                <Col xs="12">
                  {email}
                </Col>
              )) : (null)}
            </Row>
          </ModalBody>
        </Modal>
      </div>
    );
  }
}

const mapStateToProps = state => ({
  user: state.user.userData || {},
  isLoggedIn: state.user.isLoggedIn || {},
  roles: state.users.companiesRoles || {},
  company: state.company.company || {},
  outreachVouchers: state.vouchers.outreachVouchersArr || [],
  branding: state.contentManagement.branding || {},
  dashboardTooltips: state.contentManagement.outreachListTooltips || {},
});

const mapDispatchToProps = {
  fetchCompanyChanges: getCompanyChanges,
  sortVouchers: sortCompanyOutreachVouchers,
  cancelRequest: cancelCampaignRequest,
  getVouchers: getCompanyVouchers,
  cancelUnclaimedEmails: cancelUnclaimedOutreachEmails,
  fetchCompanyOutreachCampaigns: getCompanyOutreachCampaigns,
  fetchNewOutreachTooltips: getOutreachListTooltips,
};

export default withRouter(connect(mapStateToProps, mapDispatchToProps)(VouchersList));
